import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntroductionComponent } from './introduction/introduction.component';
import { FormComponent } from './form/form.component';
import { RootComponent } from './root/root.component';
import { LanguageComponent } from './language/language.component';
import { StepSegmentComponent } from './step-segment/step-segment.component';
import { StepsSegmentComponent } from './steps-segment/steps-segment.component';
import { StepDescriptionComponent } from './step-description/step-description.component';
import { FooterComponent } from './footer/footer.component';
import { FormControlComponent } from './form-control/form-control.component';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from '../app-routing.module';
import { VerificationComponent } from './verification/verification.component';
import { MobileVerificationComponent } from './mobile-verification/mobile-verification.component';
import { CanvasComponent } from './canvas/canvas.component';
import { FileInputComponent } from './file-input/file-input.component';
import { DirectiveModule } from '../directives';
import { StepsDescriptionComponent } from './steps-description/steps-description.component';
import { DesktopComponent } from './desktop/desktop.component';
import { SummarizeComponent } from './summarize/summarize.component';
import { PersonalDataComponent } from './summarize/personal-data/personal-data.component';
import { IconModule } from '@ant-design/icons-angular';
import { RadioControlComponent } from './form-control/radio-control/radio-control.component';
import { TextControlComponent } from './form-control/text-control/text-control.component';
import { FieldErrorComponent } from './form-control/field-error/field-error.component';
import { SelectControlComponent } from './form-control/select-control/select-control.component';
import { EmailControlComponent } from './form-control/email-control/email-control.component';
import { DateControlComponent } from './form-control/date-control/date-control.component';
import { CheckboxControlComponent } from './form-control/checkbox-control/checkbox-control.component';
import { AccountInformationComponent } from './summarize/account-information/account-information.component';
import { AcceptationFormComponent } from './summarize/acceptation-form/acceptation-form.component';
import { PdfAccessComponent } from './summarize/pdf-access/pdf-access.component';
import { PasswordControlComponent } from './form-control/password-control/password-control.component';
import { PasswordConfirmControlComponent } from './form-control/password-confirm-control/password-confirm-control.component';
import { AgeControlComponent } from './form-control/age-control/age-control.component';
import { TermsComponent } from './summarize/terms/terms.component';
import { RequestErrorComponent } from './summarize/request-error/request-error.component';
import { MatDialogModule } from '@angular/material/dialog';
import { CongratulationsComponent } from './congratulations/congratulations.component';
import { RepatriateComponent } from './repatriate/repatriate.component';
import { SmsValidationComponent } from './sms-validation/sms-validation.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { LoginComponent } from './login/login.component';
import { AhvControlComponent } from './form-control/ahv-control/ahv-control.component';
import { PhoneControlComponent } from './form-control/phone-control/phone-control.component';

@NgModule({
  declarations: [
    IntroductionComponent,
    FormComponent,
    RootComponent,
    LanguageComponent,
    StepSegmentComponent,
    StepsSegmentComponent,
    StepDescriptionComponent,
    FooterComponent,
    FormControlComponent,
    VerificationComponent,
    MobileVerificationComponent,
    CanvasComponent,
    FileInputComponent,
    StepsDescriptionComponent,
    DesktopComponent,
    SummarizeComponent,
    PersonalDataComponent,
    RadioControlComponent,
    TextControlComponent,
    FieldErrorComponent,
    SelectControlComponent,
    EmailControlComponent,
    DateControlComponent,
    CheckboxControlComponent,
    AccountInformationComponent,
    AcceptationFormComponent,
    PdfAccessComponent,
    PasswordControlComponent,
    PasswordConfirmControlComponent,
    AgeControlComponent,
    TermsComponent,
    RequestErrorComponent,
    CongratulationsComponent,
    RepatriateComponent,
    SmsValidationComponent,
    ConfirmationComponent,
    LoginComponent,
    AhvControlComponent,
    PhoneControlComponent,
  ],
  imports: [
    FormsModule,
    CommonModule,
    AppRoutingModule,
    DirectiveModule,
    IconModule,
    MatDialogModule,
  ],
  exports: [
    FormsModule,
    CommonModule,
    AppRoutingModule,
    DirectiveModule,
    IconModule,
    MatDialogModule,
  ],
})
export class ComponentModule {}
